import React from 'react';

const KnameBackdrop = ({ stars, glow = true }) => (
  <>
    {glow && (
      <div
        aria-hidden
        className='pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[1100px] -translate-x-1/2 -translate-y-1/2'
        style={{
          background:
            'radial-gradient(ellipse, rgba(214,162,75,0.30) 0%, rgba(160,120,70,0.12) 40%, transparent 70%)',
        }}
      />
    )}
    {stars.map((star, i) => (
      <span
        key={i}
        aria-hidden
        className='pointer-events-none absolute rounded-full bg-[#e8d5b0]'
        style={{
          left: star.x,
          top: star.y,
          width: star.s,
          height: star.s,
          opacity: star.o,
          boxShadow: `0 0 ${star.s * 3}px ${star.s}px rgba(232,213,176,0.35)`,
        }}
      />
    ))}
  </>
);

export default KnameBackdrop;
